import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import EmptyResults from '../EmptyResults';
import VerticalPercentageBarChart from '../VerticalPercentageBarChart';
import HorizontalPercentageBarChart from '../HorizontalPercentageBarChart';
import DoughnutPercentageChart from '../DoughnutPercentageChart';
import LinePercentageChart from '../LinePercentageChart';
import AnalysisTable from '../AnalysisTable';
import Tooltip from './Tooltip';
import TooltipHeader from '../TooltipHeader';

import { ChartType } from '../../enum';

function SelectiveQuestionResults(props) {
  const { question, hasResponses } = props;
  const { chartType, showDataTable, data } = question;
  const { labels, percentages, counts, values, images } = data;
  const chartRef = useRef(null);
  const isEmpty = counts.every((count) => count === 0);

  function renderChart() {
    switch (chartType) {
      case ChartType.VERTICAL_BAR:
        return (
          <VerticalPercentageBarChart
            data={percentages}
            extraDatasets={[{ data: counts, hidden: true }]}
            labels={labels}
            images={images}
            Tooltip={Tooltip}
          />
        );
      case ChartType.HORIZONTAL_BAR:
        return (
          <HorizontalPercentageBarChart
            data={percentages}
            extraDatasets={[{ data: counts, hidden: true }]}
            labels={labels}
            images={images}
            Tooltip={Tooltip}
          />
        );
      case ChartType.DOUGHNUT:
        return (
          <DoughnutPercentageChart
            data={percentages}
            extraDatasets={[{ data: counts, hidden: true }]}
            labels={labels}
            images={images}
            Tooltip={Tooltip}
          />
        );
      case ChartType.LINE:
        return (
          <LinePercentageChart
            data={percentages}
            extraDatasets={[{ data: counts, hidden: true }]}
            labels={labels}
            images={images}
            Tooltip={Tooltip}
          />
        );
      default:
        return null;
    }
  }

  if (isEmpty) <EmptyResults hasResponses={hasResponses} />;

  return (
    <div className="engage-results-engagement-screen__chart-content">
      <div className="engage-results-engagement-screen__chart-content__chart" ref={chartRef}>
        {renderChart()}
      </div>
      {showDataTable && (
        <div className="engage-results-engagement-screen__chart-content__analysis">
          <TooltipHeader
            title="Results"
            tooltipText="Percentage reflects the proportion of participants who chose each option compared to the # of participants who responded to this question"
            className="engage-results-engagement-screen__chart-content__subtitle"
          />
          <AnalysisTable
            labels={labels}
            percentages={percentages}
            counts={counts}
            values={values}
          />
        </div>
      )}
    </div>
  );
}

SelectiveQuestionResults.propTypes = {
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    chartType: PropTypes.string.isRequired,
    showDataTable: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      labels: PropTypes.arrayOf(PropTypes.string).isRequired,
      percentages: PropTypes.arrayOf(PropTypes.number).isRequired,
      counts: PropTypes.arrayOf(PropTypes.number).isRequired,
      values: PropTypes.arrayOf(PropTypes.string),
      images: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
  }).isRequired,
  hasResponses: PropTypes.bool.isRequired,
};

export default SelectiveQuestionResults;
